import React, { forwardRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import classes from "./formRichText.module.css";

export const FormRichText = forwardRef(
  (
    {
      id,
      label,
      value,
      onChange,
      disabled = false,
      required = false,
      error,
    },
    quillRef
  ) => {
    const isFilled = Boolean(
      value &&
        new DOMParser()
          .parseFromString(value, "text/html")
          .body.textContent.trim()
    );

    return (
      <div className={classes.wrapper}>
        {/* ---------- HEADING ROW ---------- */}
        <div className={classes.headingRow}>
          <span className={classes.heading}>
            {label}
            {required && (
              <span
                className={`
                  ${classes.asterisk}
                  ${isFilled ? classes.active : ""}
                  ${error ? classes.error : ""}
                  ${disabled ? classes.disabled : ""}
                `}
              >
                *
              </span>
            )}
          </span>

          {error && (
            <span className={classes.errorIcon} title={error} role="alert">
              ⚠
            </span>
          )}
        </div>

        {/* ---------- EDITOR ---------- */}
        <div
          className={`
            ${classes.editorBox}
            ${isFilled ? classes.filled : ""}
            ${disabled ? classes.disabled : ""}
            ${error ? classes.error : ""}
          `}
        >
          <ReactQuill
            ref={quillRef}
            value={value}
            onChange={onChange}
            readOnly={disabled}
            theme="snow"
            className={classes.editor}
          />
        </div>
      </div>
    );
  }
);
